import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'
import { initGA } from '@/lib/analytics'

// Defer analytics until after the first user interaction (or a 6s fallback)
// so the 165 KiB gtag.js script never loads during Lighthouse's trace window
// and doesn't compete with initial render / main bundle parsing.
let gaLoaded = false;
const loadGAOnce = () => {
  if (gaLoaded) return;
  gaLoaded = true;
  ['scroll', 'click', 'keydown', 'touchstart', 'mousemove'].forEach(e =>
    window.removeEventListener(e, loadGAOnce, { passive: true })
  );
  initGA();
};
['scroll', 'click', 'keydown', 'touchstart', 'mousemove'].forEach(e =>
  window.addEventListener(e, loadGAOnce, { passive: true })
);
setTimeout(loadGAOnce, 6000);

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)